import React from 'react';
import { Icon, IconProps } from '../icon';

import styles from './toggle-button.module.scss';

export type ToggleButtonProps = { label: string; id: string; icon: IconProps['name'] } & Pick<
  React.InputHTMLAttributes<HTMLInputElement>,
  'defaultChecked' | 'checked' | 'name' | 'value' | 'className' | 'disabled' | 'required' | 'onChange' | 'aria-label'
>;

const baseClass = `toggle-button`;

export const ToggleButton = React.forwardRef<HTMLInputElement, ToggleButtonProps>(
  (
    { id, label, disabled, name, value, defaultChecked, checked, onChange, required, 'aria-label': ariaLabel, icon },
    ref
  ) => {
    const labelId = `${id}__label`;

    return (
      <div className={styles[baseClass]} data-testid="toggle-component">
        <input
          id={id}
          type="checkbox"
          disabled={disabled}
          className={styles[`${baseClass}__input`]}
          defaultChecked={defaultChecked}
          checked={checked}
          name={name}
          value={value}
          onChange={onChange}
          aria-labelledby={labelId}
          ref={ref}
          required={required}
          aria-label={ariaLabel}
        />
        <label htmlFor={id} id={labelId} className={styles[`${baseClass}__label`]}>
          <div className={styles[`${baseClass}__label__icon-container`]}>
            <Icon name={icon} className={styles[`${baseClass}__icon`]} aria-hidden />
          </div>
          <div className={styles[`${baseClass}__label__text`]}>{label}</div>
        </label>
      </div>
    );
  }
);

ToggleButton.displayName = 'ToggleButton';
